import React, { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa';

interface PolicyAccordionItemProps {
  title: string;
  content: React.ReactNode;
  index?: number;
}

const PolicyAccordionItem = ({ title, content, index }: PolicyAccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className={`rounded-md mb-4 border bg-white border-transparent`}>
      <button
        onClick={toggleOpen}
        className="w-full text-left px-3 md:px-6 py-5 md:py-8 flex justify-between items-center"
        aria-expanded={isOpen}
      >
        <h3 className={`text-sm md:text-base font-semibold text-gray-800`}>
          {index && `${index}. `}{title}
        </h3>
        <span className={`text-primary-600 transition-transform duration-300 motion-reduce:transition-none ${isOpen ? "rotate-180" : ""}`}>
          <FaChevronDown />
        </span>
      </button>
      {/* The closed content stays mounted so it can slide; invisible keeps its links out of tab order */}
      <div
        className={`grid transition-[grid-template-rows,visibility] duration-300 motion-reduce:transition-none ${
          isOpen ? "grid-rows-[1fr] visible" : "grid-rows-[0fr] invisible"
        }`}
      >
        <div className="min-h-0 overflow-hidden">
          <div className={`px-5 md:px-6 pb-6 text-sm leading-relaxed text-gray-700`}>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PolicyAccordionItem;
